import PropTypes from "prop-types";
import React from "react";
import { Box } from "@mui/material";
import { Droppable, Draggable, DragDropContext } from "react-beautiful-dnd";
import { DragIndicator } from "@mui/icons-material";

const DragHandle = ({ dragHandleProps }) => (
  <Box display="flex" alignItems="center" mr={1} {...dragHandleProps}>
    <DragIndicator color="action" />
  </Box>
);

const ListItem = ({ render, index, isDraggingOver, draggableId }) => {
  return (
    <Draggable draggableId={`${draggableId}`} index={index}>
      {(provided, snapshot) => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          {render({
            dragHandle: (
              <DragHandle dragHandleProps={provided.dragHandleProps} />
            ),
            isDraggingOver,
            isDragging: snapshot.isDragging
          })}
        </div>
      )}
    </Draggable>
  );
};

const DraggableList = ({ items, onDragEnd, droppableId }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId} type="droppable">
        {(droppableProps, droppableSnapshot) => (
          <div ref={droppableProps.innerRef}>
            {items.length > 0 &&
              items.map(({ render, draggableId }, index) => (
                <ListItem
                  key={draggableId ? draggableId : index}
                  draggableId={draggableId}
                  render={render}
                  index={index}
                  isDraggingOver={droppableSnapshot.isDraggingOver}
                />
              ))}
            {droppableProps.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

DraggableList.propTypes = {
  items: PropTypes.array
};

export default DraggableList;
